var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { attrs: { id: "imageSelect" } }, [
    _c(
      "div",
      { staticClass: "image-section" },
      [
        _c(
          "v-icon",
          {
            staticClass: "image-icon",
            attrs: { error: _vm.images.length > _vm.max }
          },
          [_vm._v("mdi-camera")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "image-label",
            class: { invalid: this.images.length > _vm.max }
          },
          [
            _vm._v(
              "Select up to " +
                _vm._s(_vm.max) +
                " image" +
                _vm._s(_vm.max === 1 ? "" : "s") +
                " to upload."
            )
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _vm.cordova
              ? _c(
                  "v-btn",
                  {
                    staticClass: "button",
                    attrs: {
                      block: "",
                      large: "",
                      disabled: _vm.images.length >= _vm.max
                    },
                    on: { click: _vm.phonegapCamera }
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "icon", staticStyle: { opacity: ".54" } },
                      [_vm._v("mdi-camera")]
                    ),
                    _c("span", { staticStyle: { "margin-left": "8px" } }, [
                      _vm._v("Take Photo")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.android
              ? _c(
                  "v-btn",
                  {
                    staticClass: "button",
                    attrs: {
                      block: "",
                      large: "",
                      disabled: _vm.images.length >= _vm.max
                    },
                    on: { click: _vm.phonegapLibrary }
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "icon", staticStyle: { opacity: ".54" } },
                      [_vm._v("mdi-image-multiple")]
                    ),
                    _c("span", { staticStyle: { "margin-left": "8px" } }, [
                      _vm._v("Select Images")
                    ])
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.android
              ? _c(
                  "v-btn",
                  {
                    attrs: {
                      block: "",
                      large: "",
                      disabled: _vm.images.length >= _vm.max
                    },
                    on: { click: _vm.triggerImageUpload }
                  },
                  [
                    _c(
                      "v-icon",
                      { staticClass: "icon", staticStyle: { opacity: ".54" } },
                      [_vm._v("mdi-image-multiple")]
                    ),
                    _c("span", { staticStyle: { "margin-left": "8px" } }, [
                      _vm._v("Select Images")
                    ])
                  ],
                  1
                )
              : _vm._e()
          ],
          1
        ),
        _vm._v(" "),
        _c("input", {
          ref: "inputImages",
          staticClass: "image-button",
          staticStyle: {
            "pointer-events": "none",
            width: "0",
            height: "0",
            opacity: "0"
          },
          attrs: {
            accept: "image/*",
            type: "file",
            disabled: _vm.images.length >= _vm.max,
            multiple: ""
          },
          on: { change: _vm.imageChanged }
        })
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "image-preview" },
      [
        _vm._l(_vm.images, function(item, i) {
          return _c("div", { key: i }, [
            _c(
              "div",
              {
                staticClass: "image-thumb",
                style: { "background-image": "url(" + item.uri + ")" },
                on: {
                  click: function($event) {
                    _vm.openGallery(i)
                  }
                }
              },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "remove-image",
                    attrs: { color: "error", fab: "", small: "" },
                    on: {
                      click: function($event) {
                        _vm.removeImage(i, $event)
                      }
                    }
                  },
                  [
                    _c("v-icon", { attrs: { medium: "" } }, [
                      _vm._v("mdi-close")
                    ])
                  ],
                  1
                )
              ],
              1
            )
          ])
        }),
        _vm._v(" "),
        _c("div", { staticClass: "clear" })
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-432464b7", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-432464b7","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ImageSelect.vue
// module id = 495
// module chunks = 4